export const openInfoStatus = {
  OPEN: 'OPEN',
  CLOSED_PERMANENTLY: 'CLOSED_PERMANENTLY',
  CLOSED_TEMPORARILY: 'CLOSED_TEMPORARILY',
}

export const openInfoStatusOptions = [
  {
    value: openInfoStatus.OPEN,
    label: 'Open',
  },
  {
    value: openInfoStatus.CLOSED_PERMANENTLY,
    label: 'Closed Permanently',
  },
  {
    value: openInfoStatus.CLOSED_TEMPORARILY,
    label: 'Closed Temporarily',
  },
]

export const openHoursPresets = [
  {
    label: 'Open 24 hours',
    value: [
      {
        openDay: 'SUNDAY',
        closeDay: 'SUNDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 23,
          minutes: 59,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'SUNDAY',
        closeDay: 'SUNDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'MONDAY',
        closeDay: 'MONDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 23,
          minutes: 59,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'MONDAY',
        closeDay: 'MONDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'TUESDAY',
        closeDay: 'TUESDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 23,
          minutes: 59,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'TUESDAY',
        closeDay: 'TUESDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'WEDNESDAY',
        closeDay: 'WEDNESDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 23,
          minutes: 59,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'WEDNESDAY',
        closeDay: 'WEDNESDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'THURSDAY',
        closeDay: 'THURSDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 23,
          minutes: 59,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'THURSDAY',
        closeDay: 'THURSDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'FRIDAY',
        closeDay: 'FRIDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 23,
          minutes: 59,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'FRIDAY',
        closeDay: 'FRIDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'SATURDAY',
        closeDay: 'SATURDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 23,
          minutes: 59,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'SATURDAY',
        closeDay: 'SATURDAY',
        openTime: null,
        closeTime: null,
      },
    ],
  },
  {
    label: 'Workdays opens at 9 AM and close at 6 PM',
    value: [
      {
        openDay: 'SUNDAY',
        closeDay: 'SUNDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'SUNDAY',
        closeDay: 'SUNDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'MONDAY',
        closeDay: 'MONDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'MONDAY',
        closeDay: 'MONDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'TUESDAY',
        closeDay: 'TUESDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'TUESDAY',
        closeDay: 'TUESDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'WEDNESDAY',
        closeDay: 'WEDNESDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'WEDNESDAY',
        closeDay: 'WEDNESDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'THURSDAY',
        closeDay: 'THURSDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'THURSDAY',
        closeDay: 'THURSDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'FRIDAY',
        closeDay: 'FRIDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'FRIDAY',
        closeDay: 'FRIDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'SATURDAY',
        closeDay: 'SATURDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'SATURDAY',
        closeDay: 'SATURDAY',
        openTime: null,
        closeTime: null,
      },
    ],
  },
  {
    label: 'All days opens at 9 AM and close at 6 PM',
    value: [
      {
        openDay: 'SUNDAY',
        closeDay: 'SUNDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'SUNDAY',
        closeDay: 'SUNDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'MONDAY',
        closeDay: 'MONDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'MONDAY',
        closeDay: 'MONDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'TUESDAY',
        closeDay: 'TUESDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'TUESDAY',
        closeDay: 'TUESDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'WEDNESDAY',
        closeDay: 'WEDNESDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'WEDNESDAY',
        closeDay: 'WEDNESDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'THURSDAY',
        closeDay: 'THURSDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'THURSDAY',
        closeDay: 'THURSDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'FRIDAY',
        closeDay: 'FRIDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'FRIDAY',
        closeDay: 'FRIDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'SATURDAY',
        closeDay: 'SATURDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'SATURDAY',
        closeDay: 'SATURDAY',
        openTime: null,
        closeTime: null,
      },
    ],
  },
  {
    label: 'Mon - Sat opens 9 AM and close at 6 PM and closed on Sunday.',
    value: [
      {
        openDay: 'SUNDAY',
        closeDay: 'SUNDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'SUNDAY',
        closeDay: 'SUNDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'MONDAY',
        closeDay: 'MONDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'MONDAY',
        closeDay: 'MONDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'TUESDAY',
        closeDay: 'TUESDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'TUESDAY',
        closeDay: 'TUESDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'WEDNESDAY',
        closeDay: 'WEDNESDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'WEDNESDAY',
        closeDay: 'WEDNESDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'THURSDAY',
        closeDay: 'THURSDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'THURSDAY',
        closeDay: 'THURSDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'FRIDAY',
        closeDay: 'FRIDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'FRIDAY',
        closeDay: 'FRIDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'SATURDAY',
        closeDay: 'SATURDAY',
        openTime: {
          hours: 9,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 18,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'SATURDAY',
        closeDay: 'SATURDAY',
        openTime: null,
        closeTime: null,
      },
    ],
  },
  {
    label: 'Custom Hours.',
    value: [
      {
        openDay: 'SUNDAY',
        closeDay: 'SUNDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'SUNDAY',
        closeDay: 'SUNDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'MONDAY',
        closeDay: 'MONDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'MONDAY',
        closeDay: 'MONDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'TUESDAY',
        closeDay: 'TUESDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'TUESDAY',
        closeDay: 'TUESDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'WEDNESDAY',
        closeDay: 'WEDNESDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'WEDNESDAY',
        closeDay: 'WEDNESDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'THURSDAY',
        closeDay: 'THURSDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'THURSDAY',
        closeDay: 'THURSDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'FRIDAY',
        closeDay: 'FRIDAY',
        openTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
        closeTime: {
          hours: 0,
          minutes: 0,
          seconds: 0,
          nanos: 0,
        },
      },
      {
        openDay: 'FRIDAY',
        closeDay: 'FRIDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'SATURDAY',
        closeDay: 'SATURDAY',
        openTime: null,
        closeTime: null,
      },
      {
        openDay: 'SATURDAY',
        closeDay: 'SATURDAY',
        openTime: null,
        closeTime: null,
      },
    ],
  },
]

export const brazilianStates = [
  {
    state: 'Acre',
    uf: 'AC',
  },
  {
    state: 'Alagoas',
    uf: 'AL',
  },
  {
    state: 'Amapá',
    uf: 'AP',
  },
  {
    state: 'Amazonas',
    uf: 'AM',
  },
  {
    state: 'Bahia',
    uf: 'BA',
  },
  {
    state: 'Ceará',
    uf: 'CE',
  },
  {
    state: 'Distrito Federal',
    uf: 'DF',
  },
  {
    state: 'Espírito Santo',
    uf: 'ES',
  },
  {
    state: 'Goiás',
    uf: 'GO',
  },
  {
    state: 'Maranhão',
    uf: 'MA',
  },
  {
    state: 'Mato Grosso',
    uf: 'MT',
  },
  {
    state: 'Mato Grosso do Sul',
    uf: 'MS',
  },
  {
    state: 'Minas Gerais',
    uf: 'MG',
  },
  {
    state: 'Pará',
    uf: 'PA',
  },
  {
    state: 'Paraíba',
    uf: 'PB',
  },
  {
    state: 'Paraná',
    uf: 'PR',
  },
  {
    state: 'Pernambuco',
    uf: 'PE',
  },
  {
    state: 'Piauí',
    uf: 'PI',
  },
  {
    state: 'Rio de Janeiro',
    uf: 'RJ',
  },
  {
    state: 'Rio Grande do Norte',
    uf: 'RN',
  },
  {
    state: 'Rio Grande do Sul',
    uf: 'RS',
  },
  {
    state: 'Rondônia',
    uf: 'RO',
  },
  {
    state: 'Roraima',
    uf: 'RR',
  },
  {
    state: 'Santa Catarina',
    uf: 'SC',
  },
  {
    state: 'São Paulo',
    uf: 'SP',
  },
  {
    state: 'Sergipe',
    uf: 'SE',
  },
  {
    state: 'Tocantins',
    uf: 'TO',
  },
]

export const usStates = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
]

export const spanishProvinces = [
  'Álava',
  'Albacete',
  'Alicante',
  'Almería',
  'Asturias',
  'Ávila',
  'Badajoz',
  'Barcelona',
  'Burgos',
  'Cáceres',
  'Cádiz',
  'Cantabria',
  'Castellón',
  'Ceuta',
  'Ciudad Real',
  'Córdoba',
  'Cuenca',
  'Girona',
  'Granada',
  'Guadalajara',
  'Guipúzcoa',
  'Huelva',
  'Huesca',
  'Islas Baleares',
  'Jaén',
  'La Coruña',
  'La Rioja',
  'Las Palmas',
  'León',
  'Lérida',
  'Lugo',
  'Madrid',
  'Málaga',
  'Melilla',
  'Murcia',
  'Navarra',
  'Ourense',
  'Palencia',
  'Pontevedra',
  'Salamanca',
  'Santa Cruz de Tenerife',
  'Segovia',
  'Sevilla',
  'Soria',
  'Tarragona',
  'Teruel',
  'Toledo',
  'Valencia',
  'Valladolid',
  'Vizcaya',
  'Zamora',
  'Zaragoza',
]

export const defaultOpenHoursValues = [
  {
    openDay: 'SUNDAY',
    closeDay: 'SUNDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'SUNDAY',
    closeDay: 'SUNDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'MONDAY',
    closeDay: 'MONDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'MONDAY',
    closeDay: 'MONDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'TUESDAY',
    closeDay: 'TUESDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'TUESDAY',
    closeDay: 'TUESDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'WEDNESDAY',
    closeDay: 'WEDNESDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'WEDNESDAY',
    closeDay: 'WEDNESDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'THURSDAY',
    closeDay: 'THURSDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'THURSDAY',
    closeDay: 'THURSDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'FRIDAY',
    closeDay: 'FRIDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'FRIDAY',
    closeDay: 'FRIDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'SATURDAY',
    closeDay: 'SATURDAY',
    openTime: null,
    closeTime: null,
  },
  {
    openDay: 'SATURDAY',
    closeDay: 'SATURDAY',
    openTime: null,
    closeTime: null,
  },
]
